// extracted by mini-css-extract-plugin
export default {"label":"SelectOption_label__rayEB","error":"SelectOption_error__mr1iT"};